import {XauditModel} from '../../../models/xaudit.model';
import {TreatmentEndoToothGroupDataModel} from './treatment-endo-tooth-group-data.model';

export class TreatmentEndoToothGroupToothDataModel extends XauditModel {
  ToothGroupToothID: string;
  ToothGroupID: string;
  CaseWorkItemToothId: string;
  dayOfVisit: Date;
}
